module.exports = __webpack_public_path__ + "static/media/SF-2.3272ca8d.mp3";